import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/gonzales")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Gonzales, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Gonzales & Gonzales County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Gonzales, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Gonzales and Gonzales County.",
      keywords: "awnings Gonzales, awning company Gonzales, custom awnings Gonzales, sail shades Gonzales, patio covers Gonzales, pergola covers Gonzales, metal awnings Gonzales, canvas awnings Gonzales, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Gonzales", "Gonzales County"),
  }),
  component: () => <CityHomePage city="Gonzales" region="Gonzales County" />,
});
